import { NameContainer,IconButtonCredits, IconButton, RoleContainer, CountContainer } from './styles';
import {
    HorizontalSpacer, UserOutlined,
    FovSelect, FovOption, DeleteOutlined, LampOutlined,
    PeopleOutlined,
} from 'components';
import { CreditsOutlined } from 'components/icons';
import { Fragment } from 'react';
import { TEAM_ROLES } from 'utils/enums';
import constants from 'constants/index';

const light = constants.THEME.LIGHT;

export const listColumns = (theme, selectedTheme, setSelectedTeam) => ([
    {
        title: 'Team Name',
        key: 'team_name',
        width: 300,
        alignContent: 'left',
        render: (text, team) => (
            <NameContainer>{team.display_name}</NameContainer>
        ),
    },
    {
        title: 'User Count',
        key: 'user_count',
        width: 50,
        render: (text, team) => (
            <Fragment>
                <UserOutlined />
                <HorizontalSpacer size={5} />
                {team.userCount}
            </Fragment>
        ),
    },
    {
        title: 'Model Count',
        key: 'model_count',
        width: 80,
        render: (text, team) => (
            <Fragment>
                <LampOutlined />
                <HorizontalSpacer size={5} />
                {team.modelCount}
            </Fragment>
        ),
    },
    {
        title: 'Team Profile',
        key: 'team_profile',
        width: 50,
        alignContent: 'center',
        render: (text, team) => (
            <IconButton
                theme={theme}
                $selectedTheme={selectedTheme}
                onClick={() => {
                    setSelectedTeam(team);
                }}
                icon={<PeopleOutlined theme={theme} $selectedTheme={selectedTheme} />}
            />
        ),
    },
]);

export const teamMembersListColumns = (
    theme,
    selectedTheme,
    handleMemberRoleUpdate,
    setSelectedTeamMember,
    setShowMemberDelete,
    membersData,
    onCreditsClick,
) => ([
    {
        title: 'Name (Last, First)',
        key: 'name',
        width: 300,
        alignContent: 'left',
        render: (text, teamMember) => (
            <NameContainer>
                <div>{teamMember.lastName}, {teamMember.firstName}</div>
                <div>({teamMember.email})</div>
            </NameContainer>
        ),
    },
    {
        title: 'Role',
        key: 'role',
        width: 300,
        alignContent: 'left',
        render: (text, teamMember) => (
            <RoleContainer>
                <FovSelect
                    value={teamMember.role}
                    placeholder={'Select a role.'}
                    onChange={(e,newVal) => {
                        if (teamMember.role !== newVal) {
                            handleMemberRoleUpdate(teamMember.userId, newVal);
                        }
                    }}
                >
                    {TEAM_ROLES.map(role => (
                        <FovOption key={role} value={role}>
                            {role}
                        </FovOption>
                    ))}
                </FovSelect>
            </RoleContainer>
        ),
    },
    {
        title: 'Credits',
        key: 'credits',
        width: 100,
        render: (text, teamMember) => {
            const memberData = membersData[teamMember.userId];
            return (
                <IconButtonCredits
                    theme={theme}
                    $selectedTheme={selectedTheme}
                    disabled={!memberData}
                    onClick={() => onCreditsClick(memberData)}
                    icon={(
                        <CountContainer>
                            <CreditsOutlined />
                            <HorizontalSpacer size={5} />
                            {memberData?.meta_data?.find(data => data.key === 'av_points')?.value || 0}
                        </CountContainer>
                    )}
                />
            );
        },
    },
    {
        title: 'Actions',
        key: 'actions',
        width: 50,
        alignContent: 'center',
        render: (text, teamMember) => (
            <IconButton
                theme={theme}
                $selectedTheme={selectedTheme}
                hoverColor={theme.colors[selectedTheme].errorHover}
                onClick={() => {
                    setSelectedTeamMember(teamMember);
                    setShowMemberDelete(true);
                }}
                icon={
                    <DeleteOutlined
                        color={theme.colors[selectedTheme][selectedTheme === light ? 'darkGrey' : 'lightGrey']}
                        hoverColor={theme.colors[selectedTheme][selectedTheme === light ? 'darkGrey' : 'lightGrey']}
                    />
                }
            />
        ),
    },

]);
